import { render } from "./icon-picker.vue?vue&type=template&id=0ad12ede"
import script from "./icon-picker.vue?vue&type=script&lang=js"
export * from "./icon-picker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__